import { createPopper } from '@popperjs/core';
import { Offcanvas } from 'bootstrap';
import 'slick-carousel';
import './main.navigation';
import './main.landing';
import './main.newsletter';
import './main.woocommerce';
import './main.parallax';
import './main.title-decoration';
import './block.indy-page-header';
import './block.indy-teaser-slider';
import './block.indy-testimonials';
import './animations';

function addPlusMinusToNumberField() {
	$('.input-text.qty').before('<span class="remove_qty">–</span>');
	$('.input-text.qty').after('<span class="add_qty">+</span>');

	$('.remove_qty').click(function () {
		var input = $(this).parent().find('.input-text.qty');

		if((parseInt(input.val()) - 1) > 0) {
			input.val(parseInt(input.val()) - 1)
		} else {
			input.val(0)
		}
		$( '.woocommerce-cart-form :input[name="update_cart"]' ).prop( 'disabled', false ).attr( 'aria-disabled', false ).css('display', 'inline-block');
	})

	$('.add_qty').click(function () {
		var input = $(this).parent().find('.input-text.qty');

		input.val(parseInt(input.val()) + 1);
		$( '.woocommerce-cart-form :input[name="update_cart"]' ).prop( 'disabled', false ).attr( 'aria-disabled', false ).css('display', 'inline-block');
	})
}

$(document).ready(function () {
	addPlusMinusToNumberField()
});

$( document.body ).on( 'updated_wc_div', function () {
	addPlusMinusToNumberField();
} );
